module.exports = __webpack_public_path__ + "assets/blog-dummy-4.png";